import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { Button } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { defaultProductName } from 'Core/defaultValues';
import { getProductName } from '../../constants';
// Actions
import { accountAppsDelete, openAppsDelete } from '../../redux/slice';

const DeleteIntegrations = (props) => {
    const { intl: { messages } } = props;
    const dispatch = useDispatch();
    const { openDelete: open, integrationsToDelete: integrations, deleting } = useSelector(state => state.accountAppsRedux);
    const reseller = useSelector(state => state.resellerRedux?.current_reseller);

    const handleClose = () => {
        if (!deleting) dispatch(openAppsDelete({ open: false }));
    };

    return (
        <Modal
            title={messages['accountApps_deleteTitle']}
            open={open}
            position="right"
            size="small"
            handleClose={handleClose}
        >
            <ModalBody>
                <div style={{ padding: 24, overflowWrap: 'break-word' }}>
                    <Typography variant="subtitle2" color="textSecondary">
                        {messages['accountApps_deleteWarning'].replace('_PRODUCT_', getProductName(reseller, defaultProductName))}
                    </Typography>
                    {
                        integrations?.length > 0 &&
                        <ul>
                            {integrations.map((integration) => <li key={integration.id}>{integration.integrationName}</li>)}
                        </ul>
                    }
                </div>
            </ModalBody>

            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button disabled={deleting} onClick={handleClose} className="btn-cancel">
                    {messages['cancel']}
                </Button>
                <Button
                    disabled={deleting || !integrations?.length}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        dispatch(accountAppsDelete(integrations));
                    }}
                    className="btn-blue"
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default injectIntl(DeleteIntegrations);
